import AuthOrganization from "../../interfaces/identity/Organization";
import UserOrganization from "../../interfaces/Organization";
import Role, { OrganizationRole } from "../../interfaces/identity/Role";
import Region from "../../interfaces/identity/Region";
import UserInfo from "../../interfaces/UserInfo";
import { GetSubscriptionDetailsOfOrgRes } from "../../interfaces";
import { OrganizationRolePolicyDto } from "../../interfaces/superAdmin/SuperAdmin";
import { AbacPolicy } from "../../utilities/permissionUtils/PermissionUtils";

export interface AuthenticationBootstrapUserInfo {
  id: string; scid: string | null; firstName: string; lastName: string;
  displayName: string; email: string; joinDate: string | Date;
  organization: UserOrganization; roles: Role[]; regions: Region[];
}

export interface AuthenticationBootstrapData {
  requiresPasswordChange: boolean;
  requiresOnboarding: boolean;
  roles: { employeeRoles: Role[]; organizationRoles: OrganizationRole[] };
  organization: AuthOrganization | null;
  userInfo: AuthenticationBootstrapUserInfo | null;
  permissions: AbacPolicy[];
  rolePolicies: OrganizationRolePolicyDto[];
  userAddedInRolePolicy: boolean;
  subscription: GetSubscriptionDetailsOfOrgRes | null;
}

interface BootstrapApiResponse { data: AuthenticationBootstrapData | null; success: boolean; message?: string; }

export class AuthenticationBootstrapError extends Error {
  constructor(public readonly status: number, message = "Authentication bootstrap failed.") {
    super(message);
    this.name = "AuthenticationBootstrapError";
  }
}

export const bootstrapAuthentication = async (token: string, identityTransition = false): Promise<AuthenticationBootstrapData> => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/Authentication/bootstrap`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", "Cache-Control": "no-store" },
    body: JSON.stringify({ identityTransition }),
  });
  let payload: BootstrapApiResponse | null = null;
  try { payload = await response.json(); } catch { /* status is enough for the safe failure screen */ }
  if (!response.ok || !payload?.success || !payload.data) {
    throw new AuthenticationBootstrapError(response.status, payload?.message);
  }
  return payload.data;
};

export const mapBootstrapUserInfo = (userInfo: AuthenticationBootstrapUserInfo | null): UserInfo | null => {
  if (userInfo == null) return null;
  return {
    ...userInfo,
    scid: userInfo.scid ?? null,
    joinDate: new Date(userInfo.joinDate),
    organization: userInfo.organization,
  };
};
